import { combineReducers } from 'redux'

import resultados from './despesasMensaisPorFornecedor'

export default combineReducers({ resultados })
